export const GuestPages = [
  "home",
  "login",
  "register",
  "password-request",
  "password-reset",
  "courses",
  "course-detail",
  "bundle-course-detail",
  "guest-payment",
  "not-found",
  "verify-email",
  "instructor-detail",
  "term-and-condition",
];
